import FormattedMessage from 'I18n/components/FormattedMessage';
import PropertySection from 'framework-asset-preview-lib/internal/properties/components/propertySections/PropertySection';
import { getStatusPropertyName } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import ObjectStatus from 'framework-asset-preview-lib/components/ObjectStatus';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Shared status section components for all object types that have a status (PUBLISHED, DRAFT, SCHEDULED...)
 * This component is meant to be used inside of any [AssetName]PreviewSidepanel or [AssetName]PreviewPopover component.
 */
export default function StatusPropertySection({
  crmObject,
  hideLabel,
  renderValueAs,
  tagsPrefix = [],
  tagsSuffix = [],
  useComponent = 'UITag',
  nonCrmObject
}) {
  const propertyName = getStatusPropertyName(crmObject);
  if (!propertyName) {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertySection, {
    crmObject: crmObject,
    hideLabel: hideLabel,
    properties: [],
    propertyName: propertyName,
    renderLabel: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkAssetPreviewLib.propertyLabel.shared.status"
    }),
    renderValueAs: renderValueAs,
    renderValue: () => {
      return [...tagsPrefix, /*#__PURE__*/_jsx(ObjectStatus, {
        crmObject: crmObject,
        properties: [],
        nonCrmObject: nonCrmObject,
        useComponent: useComponent
      }, `StatusPropertyValue-${crmObject.objectId}`), ...tagsSuffix];
    }
  });
}